<template>
<easy-data-table
	class="data-table"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="tableHeaders"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	sort-by="time"
	sort-type="desc"
	:rows-items="[20,50,100]"
	:rows-per-page="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="180"
	:table-height="250"
	:loading="isLoading"
	alternating
	buttons-pagination
>
	<!-- If rows is empty -->
	<template #empty-message>
		Записів не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		<!-- {{ time === undefined ? "-" : timeToString(time) }} -->
		{{ timeFromNowPromt(time) }}
	</template>
</easy-data-table>
</template>


<script>
import {
	fixNumberPrecision,
	dateTimeToDateString,
	numberToKnumber,
	timeFromNowPromt,
	easyDataTableRowsPerPage,
} from '@/helpers.js'
import { RESOURCE_NAMES, readResources } from '@/api/api.js'
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import { usePostsStore } from '@/stores/PostsStore'
//import { Station } from '../../station'
import { Post } from '@/models/post'

export default {
	components: {
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	emits: {
		"posts": value => Array.isArray(value),
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const postsStore = usePostsStore()

		return {
			accountStore,
			stationsStore,
			postsStore,
			fixNumberPrecision,
			numberToKnumber,
			dateTimeToDateString,
			timeFromNowPromt,
			easyDataTableRowsPerPage,
		}
	},

	data() {
		return {
			isLoading: true,
			// Table
			rowsPerPage: 20,
			tableHeaders:[
				{ text: "Назва", value: Post.passportKeys.name, sortable: true, width: 300, },
				{ text: "Час", value: "time", width: 160, },
				{ text: "Eavg", value: Post.metricsKeys.Eavg },
				{ text: "Emin", value: Post.metricsKeys.Emin },
				{ text: "Emax", value: Post.metricsKeys.Emax },
			],

			tableItems: [],
		}
	},

	async created() {
		// If no posts in storage - read posts and posts metrics
		if (this.postsStore.isNoPosts) {
			await this.postsStore.readPosts()
			await this.postsStore.readMetrics((result) => {
				if (!result) {
					console.error("on read posts metrics")
				}
			})
		}

		this.readTableData()
	},

	mounted() {
		this.rowsPerPage = easyDataTableRowsPerPage(this.tableHeight)
	},

	methods: {
		async readTableData() {
			//let rows = Array()
			this.isLoading = true

			const filters=`where={"${Post.passportKeys.relatedStations}":"${this.stationId}"}`

			this.tableItems.length = 0
			// Read related posts for current station
			this.tableItems = await readResources(
				RESOURCE_NAMES.postPassports,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
				[filters,]
			).then(response => {
				response.forEach(it => {
					//console.log("Table post id", it._id)
					// console.log("Table post", it)
					const post = this.postsStore?.post(it._id)
					
					it["time"] = post?.getMetric(Post.metricsKeys.Eavg)?.time
					it[Post.metricsKeys.Eavg] = post?.getMetric(Post.metricsKeys.Eavg)?.value
					it[Post.metricsKeys.Emin] = post?.getMetric(Post.metricsKeys.Emin)?.value
					it[Post.metricsKeys.Emax] = post?.getMetric(Post.metricsKeys.Emax)?.value
				})

				//console.log("Table posts", response)
				this.isLoading = false
				return response
			}).catch(() => {
				this.isLoading = false
				return null
			})

			this.$emit('posts', this.tableItems)
		},
	},

	computed: {
		station() {return this.stationsStore.station(this.stationId) },

		tableHeight() { return 250 },
	},
}
</script>


<style src="@/assets/table.css" scoped></style>
<style scoped>

</style>